.ux-iws-nb-chapter-intro {
    display: block;
    position: relative;
    box-sizing: border-box;
    padding: 0;
    @include font(light);

    &[separator] {
        border-top: 2px solid $color-black-6;
    }

    &__chapter {
        display: block;
        padding: 30px 15px 0;
        box-sizing: border-box;

        @media (min-width: 568px) {
            padding: 30px 30px 0;
        }

        @media (min-width: 1024px) {
            padding: 60px 30px 30px;
        }
    }

    &__chapter-label {
        @include font(light);
        position: relative;
        display: inline-block;
        padding-top: 14px;
        font-size: 20px;
        line-height: 1.2;

        &::before {
            content: "";
            display: block;
            width: 30px;
            height: 6px;
            background-color: $color-blue-1;
            position: absolute;
            left: 0;
            top: 0;
        }
    }

    &__header {
        display: block;
        padding: 30px 15px;
        margin: 0;

        @media (min-width: 568px) {
            padding: 30px;
        }

        @media (min-width: 1024px) {
            padding-left: calc(100% / 12);
            padding-right: calc(100% / 12);
            padding-bottom: 60px;
        }

        @media (min-width: 1440px) {
            padding-bottom: 100px;
        }
    }

    &__title {
        margin-bottom: 30px;

        @media (min-width: 1440px) {
            margin-bottom: 60px;
        }
    }

    &__title,
    &__text {
        max-width: 640px;

        @media (min-width: 1440px) {
            max-width: 900px;
        }

        @media (min-width: 1800px) {
            max-width: 1200px;
        }
    }

    &__text {
        @include nb-text();
    }

    &__tags {
        @include nb-tag-list();
        margin: 0 0 15px;
    }

    &__tag {
        @include nb-tag();
    }

    h1,
    h2,
    h3 {
        @include nb-heading(2, true);
        margin: 0;
    }

    p {
        margin: 0;

        &:not(:last-of-type) {
            margin-bottom: 10px;
        }
    }

    [slot="subtitle"] {
        @include nb-heading(2, false);
        margin: 0;
    }

    .is-hidden {
        display: none;
    }
}
